import type { ColumnProps } from "@shared/frontend/hyper-table/types";
import type { Association } from "@entities";

export type RelevantVolunteersDistanceMeta = {
  distanceByUserId?: Record<string, number | null>;
  isRemoteOpportunity?: boolean;
};

export function formatRelevantVolunteerDistance(
  km: number | null | undefined,
  isRemoteOpportunity?: boolean,
): string {
  if (km == null) return isRemoteOpportunity ? "מרחוק" : "-";
  if (km < 1) return `${Math.round(km * 1000)} מ'`;
  return `${km.toFixed(1)} ק"מ`;
}

export function distanceMapFromMeta(
  meta: RelevantVolunteersDistanceMeta | undefined,
): Map<string, number | null> | null {
  const raw = meta?.distanceByUserId;
  if (!raw || typeof raw !== "object") return null;
  return new Map(
    Object.entries(raw).map(([userId, distance]) => [
      userId,
      distance == null ? null : Number(distance),
    ]),
  );
}

export function distanceMapToMeta(
  distanceByUserId: Map<string, number | null>,
): Record<string, number | null> {
  return Object.fromEntries(distanceByUserId.entries());
}

export function splitVolunteerColumnsForDistance(
  columns: ColumnProps<Association>[],
) {
  const addressIndex = columns.findIndex(
    (column) => column.field === "user.address",
  );
  const splitAt = addressIndex >= 0 ? addressIndex + 1 : 3;
  return {
    columnsBeforeDistance: columns.slice(0, splitAt),
    columnsAfterDistance: columns.slice(splitAt),
  };
}
